"use client";
import { useTranslations } from "next-intl";
import { HeroSection } from "./sections/Herosection";
import { AuroraBackground } from "@/components/ui/AuroraBackground";
import { ScrollingBannerSection } from "./sections/ScrollingBannerSection";
import { ProjectCarouselSection } from "@/[locale]/sections/ProjectCarouselSection";
import { ProjectsSection } from "./sections/ProjectsSection";
import { WhyChooseUsSection } from "./sections/WhyChooseUsSection";
import { FormulasSection } from "./sections/FormulasSection";
import { FAQSection } from "./sections/FAQSection";
import { CTASection } from "./sections/CTASection";
import { Phone } from "@/components/ui/Phone";

export default function Home() {
  return (
    <>
      <AuroraBackground>
        <HeroSection />
        <ScrollingBannerSection />
      </AuroraBackground>
      <ProjectCarouselSection />
      <Phone />
      <ProjectsSection />
      <WhyChooseUsSection />
      <FormulasSection />
      <FAQSection />
      <CTASection />
    </>
  );
}
